// LIBRERIE
import React from "react";
import { useTranslation } from "react-i18next";
import { Link } from "react-router-dom";

const Presentation: React.FC = () => {
    
    const { t } = useTranslation();

    return(
        <section id="valutazione">
            <div className="container-fluid px-0">
                <div className="row">
                    <div className="col-12 col-lg-6 d-flex">
                        <div className="px-3 py-5 px-lg-5 m-auto">
                            <h2>{t('homePage.sellBanner.title')}</h2>
                            <p dangerouslySetInnerHTML={{ __html: t('homePage.sellBanner.para1') as string }}></p>
                            <p dangerouslySetInnerHTML={{ __html: t('homePage.sellBanner.para2') as string }}></p>
                            <p dangerouslySetInnerHTML={{ __html: t('homePage.sellBanner.para3') as string }}></p>
                            <Link to={'/valutazione'} title={t('homePage.sellBanner.linkTitle') as string} className="btn-primary ml-auto">
                                <span> {t('homePage.sellBanner.btnText')}</span>
                            </Link>
                        </div>
                    </div>
                    <div className="col-12 col-lg-6 px-0">
                        <div className="img-wrapper">
                            <img src="/assets/images/inHome/valutazione.webp" alt={t('homePage.sellBanner.imageAlt') as string} />
                        </div>
                    </div>
                </div>
            </div>
        </section>
    )
}
export default Presentation;